// extracted by mini-css-extract-plugin
export var textInput = "_dg-0";